import { useAuthInfiniteList } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { EnrollApi } from 'api';
import { IEnroll } from 'types';
import { KEY } from './keys';

function useGetInfiniteByEvent(eventId: number, name?: string, size = 30) {
  return useAuthInfiniteList<IEnroll>(
    [...getQueryKeys([KEY]).lists(), 'infinite', { eventId, name, size }],
    (page) =>
      EnrollApi.getAll({ eventId, page, size, ...(name ? { name } : {}) }),
    !!eventId,
  );
}

export default useGetInfiniteByEvent;
